import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from '../auth/services/app-config.service';

@Injectable()
export class LocalApiProxyInterceptor implements HttpInterceptor {
  constructor(private appConfig: AppConfigService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isLocalhost = ['localhost', '127.0.0.1'].includes(window.location.hostname);
    const config = this.appConfig.config;

    if (isLocalhost && config.backendUrl) {
      const apiPrefixes = [config.baseUrl, config.baseUrlLogin]
        .filter(Boolean)
        .map(baseUrl => new URL(`${baseUrl}${config.backendUrl}`));
      const requestUrl = new URL(request.url, window.location.origin);
      const matchesPoisApi = apiPrefixes.some(prefix =>
        requestUrl.origin === prefix.origin &&
        (requestUrl.pathname === prefix.pathname || requestUrl.pathname.startsWith(`${prefix.pathname}/`))
      );

      if (matchesPoisApi) {
        request = request.clone({ url: `${requestUrl.pathname}${requestUrl.search}` });
      }
    }

    return next.handle(request);
  }
}
